import React from 'react'
import { Form } from "react-bootstrap";
const FilterNumber = ({onChange,value }) => {
    const options = [10, 25, 50, 100,500];
    return (
        <>
            <Form.Select
                  value={value}
                 onChange={(e) => onChange(Number(e.target.value))}
                className="me-2"
                style={{ width: "60px", padding: "11px" }}
            >

                {options.map((num) => (
                    <option key={num} value={num}>
                        {num}
                    </option>
                ))}

            </Form.Select>
        </>

    )
}

export default FilterNumber